export class Computer {
  Type: string;
  Icon: string;
  DistToDest: number;
  TimeToDest: number;
  BatteryReservedWarning: boolean;

  constructor(type: string, icon: string, distToDest: number, timeToDest: number, batteryReservedWarning: boolean) {
    this.Type = type;
    this.Icon = icon;
    this.DistToDest = distToDest;
    this.TimeToDest = timeToDest;
    this.BatteryReservedWarning = batteryReservedWarning;
  }
}
